const rowEvents: string[] = [
  'rowClick',
  'rowDblClick',
  'rowContext',
  'rowTap',
  'rowDblTap',
  'rowTapHold',
  'rowMouseEnter',
  'rowMouseLeave',
  'rowMouseOver',
  'rowMouseOut',
  'rowMouseMove',
  'rowAdded',
  'rowUpdated',
  'rowDeleted',
  'rowMoved',
  'rowResized',
];

export default rowEvents;
